import Modal from "./modal.component.js";

export default angular
    .module("oui.modal", [])
    .component("ouiModal", Modal)
    .name;
